"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionSocketEvent = void 0;
var AuctionSocketEvent;
(function (AuctionSocketEvent) {
    AuctionSocketEvent["JoinRoom"] = "auction:joinRoom";
    AuctionSocketEvent["LeaveRoom"] = "auction:leaveRoom";
    AuctionSocketEvent["BidsUpdated"] = "auction:bidsUpdated";
})(AuctionSocketEvent || (exports.AuctionSocketEvent = AuctionSocketEvent = {}));
